<template>
  <div class="container">
    <div class="common-layout">
      <el-container>
        <!-- :style="{ height:width > 760 ? '108px' : '62px'}" -->
        <el-header :style="{ background:'transparent'}">
          <Header class="navbar-container"></Header>
        </el-header>
        <div class="content-container css-gradient">
          <el-main class="main-container">
            <Main></Main>
          </el-main>
        </div>
      </el-container>
    </div>
  </div>
</template>
<script>
import Header from './components/header.vue'
import Main from './components/main.vue'
export default {
  components: {
    Header,
    Main,
  },
  data() {
    return {
      width:0,
    }
  },
  created(){
    console.log('width')
    this.width = window.innerWidth
    window.onresize = () => {
      console.log('onresize')
      this.width = window.innerWidth; //实时宽度
      console.log(this.width)
    };
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.module.scss';
@import '@/styles/mixin.scss';
.common-layout {
  height: 100%;
  margin: 0;
  padding: 0;
  @include clearfix;
  .el-container {
    height: 100%;
    margin: 0;
    padding: 0;
    @include clearfix;
    @include relative;
  }

  .el-header {
    padding: 0;
    background:transparent !important;
    // --el-header-height: $navbarHeight;
  }
  .header-panel-container {
    height: auto !important;
  }
  .el-main {
    --el-main-padding: 0px;
  }
}
</style>